module.exports = __webpack_public_path__ + "img/denmark-diabetes-mellitus-female.42a89062.png";